import Modal from 'react-modal'
import './login-modal.css';
import agent from '../agent';
import React from 'react';
import { isEmail } from 'validator';
import EmailVerificationModal from './EmailVerificationModal.js';
import { BACKEND_URL } from '../constants/constants';

class SignUpModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showLoginPrompt: false,
      username: '',
      password: '',
      confirm: '',
      showError: false,
      errorMsg: 'Enter a valid email and password of at least 6 characters',
      handle: '',
      isPasswordReset: false
    }
    this.openLoginPrompt = this.openLoginPrompt.bind(this);
    this.openLoginModal = this.openLoginModal.bind(this);
    this.closeLoginPrompt = this.closeLoginPrompt.bind(this);
    this.handleUsernameChange = this.handleUsernameChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleConfirmChange = this.handleConfirmChange.bind(this);
    this.submitCredentials = this.submitCredentials.bind(this);
  }

  openLoginPrompt ({ handle, isPasswordReset }) {
    this.setState({ showLoginPrompt: true });
    this.setState({ handle });
    this.setState({ isPasswordReset });
    this.setState({ errorMsg: '' });
  }
  
  closeLoginPrompt () {
    this.setState({ showLoginPrompt: false });
  }

  removeError = () => {
    this.setState({ showError: false });
    this.forceUpdate() 
  }

  handleUsernameChange (e) {
    this.setState({ username: e.target.value });
    this.removeError()
  }

  handlePasswordChange (e) {
    this.setState({ password: e.target.value });
    this.removeError()
  }

  handleConfirmChange (e) {
    this.setState({ confirm: e.target.value });
    this.removeError()
  }

  submitCredentials () {
    const isValidUsername = isEmail(this.state.username)
    const isSufficientLength = (this.state.password.length >= 6)
    const isSamePassword = (this.state.password === this.state.confirm)
    if (!isValidUsername) {
      this.setState({ errorMsg: 'Enter a valid email' })
      this.setState({ showError: true });
    } else if (!isSufficientLength) {
      this.setState({ errorMsg: 'Password must be 6 characters or more' })
      this.setState({ showError: true });
    } else if (!isSamePassword) {
      this.setState({ errorMsg: 'Both passwords must match' })
      this.setState({ showError: true });
    } else {
      agent.Profile.check(this.state.username, this.state.isPasswordReset).then(() => {
        this.refs.EmailVerificationModal.openLoginPrompt(this.state.username, this.state.password, this.state.handle)
        this.closeLoginPrompt()
        this.setState({ showError: false });
      })
      .catch(error => {
        if (this.state.isPasswordReset) {
          this.setState({ errorMsg: 'User does not exist' })
        } else {
          this.setState({ errorMsg: 'User already exists' })
        }
        this.setState({ showError: true });
      })
    }
  }

  openLoginModal (event) {
    if (event) event.preventDefault()
    this.closeLoginPrompt()
    let container = this.props.container
    container.openLoginPrompt()
  }

  render() {
    return (
      <div>
        <Modal
          isOpen={this.state.showLoginPrompt}
          onRequestClose={this.closeLoginPrompt}
          className="login-modal"
          overlayClassName="Overlay">
          
          <img src={`${BACKEND_URL}/assets/logo-grey.png`}></img>
          <div className="title">
            { this.state.isPasswordReset ? 'Reset Account Details' : 'Sign up for an account' }
          </div>
          <input className="username" placeholder="Email address" autoFocus onChange={this.handleUsernameChange}></input>
          <input className="password" type="password" placeholder="Password (6+ characters)" onChange={this.handlePasswordChange}></input>
          <input className="confirm" type="password" placeholder="Confirm Password" onChange={this.handleConfirmChange}></input>
          <div className="error" style={ this.state.showError ? { visibility: "visible" } : { visibility: "hidden" } }>{ this.state.errorMsg }</div>
          <div className="submit" onClick={this.submitCredentials}>
            Submit
          </div>
          <div className="cancel-container">
            <div className="cancel-prompt">Already a member?</div>
            <a className="cancel-btn" onClick={ this.openLoginModal }>Log in here.</a>
          </div>
        </Modal>
        <EmailVerificationModal container={this} ref="EmailVerificationModal"/>
      </div>
    )
  }
}

export default SignUpModal


// WEBPACK FOOTER //
// ./src/components/signUpModal.js